'use strict';

export function maskAccountNumber(value) {
  const s = String(value || '').trim();
  if (!s) return '—';
  if (s.length <= 4) return '****';
  return `${'*'.repeat(Math.min(8, s.length - 4))}${s.slice(-4)}`;
}

export function maskPan(value) {
  const s = String(value || '').trim().toUpperCase();
  if (s.length < 5) return '—';
  if (s.length < 10) return `${s.slice(0, 2)}****`;
  return `${s.slice(0, 5)}****${s.slice(-1)}`;
}
